module.exports = __webpack_public_path__ + "0a71930d3ed49e17a7bae40541ff09d6.svg";